<template>
  <div id="themeWorks">
    <div class="themeWorks-container">
      <div class="search-box">
        <div class="icon-box">
          <i class="el-icon-search"></i>
        </div>
        <div class="input-box">
          <input v-model="name" @keyup.enter="getList(1)" />
        </div>
      </div>
      <div class="bread-title">
        <div class="list-name">
          {{ type == 2 ? "自由主题作品" : "主题作品" }}
        </div>
        <ul class="tabs">
          <li
            class="tabs-item"
            @click="tabChange('1', 'cate')"
            :class="[tab == 1 ? 'active' : '']"
          >
            平面类
          </li>
          <li
            class="tabs-item"
            @click="tabChange('2', 'cate')"
            :class="[tab == 2 ? 'active' : '']"
          >
            动画类
          </li>
        </ul>
        <div class="sort">
          排序方式：<span
            @click="tabChange('1', sort)"
            :class="{ active: sortActive == 1 }"
            >时间</span
          >
          <i> | </i>
          <span
            @click="tabChange('2', sort)"
            :class="{ active: sortActive == 2 }"
            >浏览</span
          >
        </div>
      </div>
      <div class="works-box">
        <div
          class="works-item"
          v-for="(item, index) in list.workList"
          :key="index"
          @click="goDetail(item)"
        >
          <div
            class="works-item-cover"
            :style="{
              backgroundImage:
                'url(' +
                item.cover +
                '?x-oss-process=image/resize,m_mfit,w_200,h_165)',
            }"
          ></div>
          <div class="works-item-bottom">
            <div class="work-item-name">{{ item.name }}</div>
            <div class="work-item-autor-box">
              <div class="work-item-author">{{ item.authorName }}</div>
              <div class="work-item-views">
                <i class="el-icon-view"></i>
                <span style="vertical-align: middle">{{ item.viewCount }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pagination">
        <el-pagination
          v-if="pageInfo.total > 12"
          @current-change="getList"
          :currentPage="pageInfo.pageNum"
          :page-size="pageInfo.pageSize"
          layout=" prev, pager, next"
          :total="pageInfo.total"
          style="text-aligin: right"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive, ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { listByPage } from "../utils/apis/worksApi";
export default {
  name: "themeWorks",
  setup() {
    const tab = ref(1);
    const sortActive = ref(1);
    const route = useRoute();
    const router = useRouter();
    const name = ref("");
    const pageInfo = reactive({
      pageSize: 15,
      pageNum: 1,
      total: 13,
    });
    const list = reactive({
      workList: [],
    });
    let type = ref(route.name !== "freeThemeWorks" ? 1 : 2);

    watch(
      () => route.name,
      (val) => {
        //重置
        if (val === "freeThemeWorks" || val === "themeWorks") {
          type.value = val !== "freeThemeWorks" ? 1 : 2;
          tab.value = 1;
          sortActive.value = 1;
          tab.value = 1;
          pageInfo.pageNum = 1;
          pageInfo.total = 13;
          list.workList = [];
          getList(1);
        }
      }
    );

    const coverImage = ref(
      "https://cyc-test.oss-cn-shanghai.aliyuncs.com/design-competition/2021-04-23/16191407496701618967035552.jpg"
    );
    function tabChange(key, category) {
      if (category == "cate") {
        tab.value = key;
      } else {
        sortActive.value = key;
      }
      getList(1);
    }

    getList(1);

    function getList(value) {
      pageInfo.pageNum = value;
      let params = {
        category: tab.value,
        pageNum: pageInfo.pageNum,
        pageSize: pageInfo.pageSize,
        sortRule: sortActive.value,
        name: name.value,
        competitionUnit: type.value,
      };

      listByPage(params).then((res) => {
        // console.log(res);
        if (res.data.code === 200) {
          list.workList = res.data.data.list;
          pageInfo.total = res.data.data.total;
        }
      });
    }

    function goDetail(item) {
      if (type.value === 1) {
        if (tab.value == 1) {
          //主题详情 -平面
          router.push({
            path: "/themeWorks/imageWorkDetail",
            query: { id: item.id, type: type.value, views: item.viewCount },
          });
        } else {
          //主题详情 -动画
          router.push({
            path: "/themeWorks/videoWorkDetail",
            query: { id: item.id, type: type.value, views: item.viewCount },
          });
        }
      } else {
        if (tab.value == 1) {
          //自由主题详情 -平面
          router.push({
            path: "/freeThemeWorks/imageWorkDetail",
            query: { id: item.id, type: type.value, views: item.viewCount },
          });
        } else {
          //自由主题详情 -动画
          router.push({
            path: "/freeThemeWorks/videoWorkDetail",
            query: { id: item.id, type: type.value, views: item.viewCount },
          });
        }
      }
    }

    return {
      tab,
      tabChange,
      sortActive,
      coverImage,
      route,
      router,
      type,
      pageInfo,
      getList,
      list,
      goDetail,
      name,
    };
  },
};
</script>
<style lang="less" scoped>
#themeWorks {
  background-color: #f7f7f7;
  .themeWorks-container {
    max-width: 1600px;
    min-width: 1200px;
    margin: 0 auto;
    padding-top: 30px;
  }
  .search-box {
    margin: 0 0 25px 0;
    height: 30px;
    display: flex;
    line-height: 30px;
    border-radius: 15px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    width: 240px;
    padding-left: 15px;
    .icon-box {
      font-size: 22px;
      color: #dcdfe6;
    }
    .input-box {
      font-size: 0px;
      height: 28px;
      padding-left: 10px;
    }
    .input-box input {
      border: none;
      box-sizing: border-box;
      height: 100%;
      outline: none;
      color: #909399;
      width: 170px;
      background-color: inherit;
    }
  }

  .bread-title {
    height: 30px;
    line-height: 30px;
    overflow: hidden;
  }
  .list-name {
    float: left;
    margin-right: 25px;
  }
  .tabs {
    float: left;
    overflow: hidden;
    border-radius: 5px;
    // margin-left: 30px;
    li {
      float: left;
      width: 72px;
      text-align: center;
      background-color: #fff;
      cursor: pointer;
    }
    li:hover {
      color: #fff;
      background-color: #013589;
    }
    li.active {
      color: #fff;
      background-color: #013589;
    }
  }
  .sort {
    float: right;
    color: #303133;
    i {
      font-style: normal;
    }
    span {
      cursor: pointer;
      color: #909399;
    }
    span:hover {
      color: #003588;
      font-weight: bold;
    }
    span.active {
      color: #003588;
      font-weight: bold;
    }
  }
  .works-box {
    padding-top: 23px;
    min-height: 600px;
    margin-left: -24px;
    display: flex;
    flex-wrap: wrap;

    .works-item {
      margin-left: 24px;
      width: calc((100% - 120px) / 5);
      // flex: 0.25;
      height: 352px;
      margin-bottom: 25px;
      background-color: #fff;
      border-radius: 4px;
      overflow: hidden;
      border: 1px solid #fff;
      box-sizing: border-box;
      // flex-shrink: 0;
      .works-item-cover {
        height: 246px;
        // width: 382px;
        background-size: cover;
        background-position: center;
      }
    }
    .works-item-bottom {
      height: calc(100% - 246px);
      padding: 20px;
      box-sizing: border-box;
      .work-item-name {
        color: #000000;
        font-weight: bold;
        font-size: 18px;
        height: 20px;
        line-height: 20px;
        box-sizing: border-box;
      }
      .work-item-autor-box {
        height: calc(100% - 20px);
        position: relative;
        .work-item-author {
          position: absolute;
          left: 0;
          bottom: 0;
          color: #303133;
        }
        .work-item-views {
          display: inline-block;
          position: absolute;
          right: 0;
          bottom: 0;
          color: #909399;
          font-size: 14px;
          i {
            font-size: 18px;
            margin-right: 8px;
            vertical-align: middle;
          }
        }
      }
    }
    .works-item:hover {
      border-color: #013589;
      cursor: pointer;
    }
  }
  .pagination {
    text-align: center;
    margin-top: 25px;
    padding-bottom: 85px;
  }
  .pagination /deep/ .el-pager li {
    background-color: #f7f7f7;
  }
  .pagination /deep/ .el-pager li.active {
    color: #2397ff;
  }
  .pagination /deep/ .el-pagination .btn-next,
  .pagination /deep/ .el-pagination .btn-prev {
    background-color: #f7f7f7;
  }
}
</style>
